import { Link, useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#1a1d29] text-white pb-8 pt-8">

      <div className="max-w-6xl mx-auto px-2">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-8">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <img src="./assets/logo.webp" className="h-12 lg:h-14" alt="Logo" />
            <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 font-semibold cursor-pointer">
              <li onClick={() => navigate('/')} className="hover:text-yellow-400">Home</li>
              <li onClick={() => navigate('/games')} className="hover:text-yellow-400">Games</li>
              <li onClick={() => navigate('/news')} className="hover:text-yellow-400">News</li>
              <li onClick={() => navigate('/support')} className="hover:text-yellow-400">Support</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 my-6" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <p>Copyright © thegameio | Designed by <span className="text-yellow-400">thegameio</span></p>
          <div className="flex gap-6"><span className="hover:text-white cursor-pointer">Privacy</span><Link to="/terms-of-service" className="hover:text-white">Terms &amp; Conditions</Link></div>
        </div>
      </div>
      <div className="block md:hidden h-32" />
    </footer>
  );
}

export default Footer;
